import React from 'react';
import ResetPasswordForm from '../../../components/forms/ResetPasswordForm';
import { AuthLayout } from '../../../components/layouts/AuthLayout';

export function ResetPasswordPage() {
  return (
    <AuthLayout
      title="Criar nova senha"
      description="Use uma senha forte e diferente das senhas anteriores."
    >
      <ResetPasswordForm />
    </AuthLayout>
  );
}
